module.exports = __webpack_public_path__ + "img/logo.420e0347.png";